/**
 * Shared chrome for the controls that float over the angle image — the ⋯
 * concept menu and the render-carousel arrows, on both the main angle and the
 * derivative cards. One constant so the two call sites can never drift.
 *
 * Theme-aware on purpose: the pill lands EITHER on the photo (image fills the
 * frame) OR on the letterbox strip beside it (height-bound image), so it has
 * to stay legible over both.
 *
 * - Light: white scrim + dark glyph — reads over a bright sky and over the
 *   near-white letterbox alike.
 * - Dark: the letterbox is near-black (`--image-backdrop`), where the white
 *   scrim + #545454 glyph collapsed into the background and the ⋯ menu was
 *   effectively invisible. Dark therefore inverts the pair — dark scrim, white
 *   glyph — so the contrast lives BETWEEN glyph and scrim instead of relying
 *   on the surface behind them.
 */
export const ANGLE_OVERLAY_PILL =
  'before:bg-white/35 before:backdrop-blur-sm dark:before:bg-black/45';

/** Glyph tint that pairs with {@link ANGLE_OVERLAY_PILL}. */
export const ANGLE_OVERLAY_GLYPH =
  '[&_svg]:text-[#545454] dark:[&_svg]:text-white';

/** Both halves, for buttons that carry an icon (the ⋯ menu). */
export const ANGLE_OVERLAY_BUTTON = `${ANGLE_OVERLAY_GLYPH} ${ANGLE_OVERLAY_PILL}`;
